export const GATE_POSITION_THRESHOLDS = {
  CLOSED: 5,
  OPEN: 95,
};
